export const durationOptions = [
  { label: 'This Week', value: 'currentweek' },
  { label: 'Last 12 Months', value: 'last12months' },
  { label: 'Last 6 Years', value: 'last6years' },
  { label: 'All', value: 'all' }
];
